<div class="bm-debt-collection">
    <div *ngIf="busy" class="loading-indicator">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <div *ngIf="error" class="error-message">
        <p-message severity="error" [text]="error"></p-message>
    </div>

    <div *ngIf="initialized && !busy" class="grid min-h-0">
        <div class="col-8 scroll-panel">
            <bm-debt-collection-activity></bm-debt-collection-activity>
        </div>
        <div class="col-4 scroll-panel">
            <p-tabs [(value)]="tabIndex">

                <!-- TAB HEADERS -->
                <p-tablist>

                    <!-- Invoice Overview (static) -->
                    <p-tab [value]="0">
                        Invoice Overview
                    </p-tab>

                    <!-- Contract Overview (dynamic & closable) -->
                    @if (selectedContract) {
                        <p-tab [value]="1">
                            <div class="flex align-items-center gap-2">
                                <span>Contract Overview</span>
                                <i
                                        class="pi pi-times cursor-pointer"
                                        (click)="closeContractToolbar(); $event.stopPropagation()">
                                </i>
                            </div>
                        </p-tab>
                    }

                </p-tablist>

                <!-- TAB PANELS -->
                <p-tabpanels>

                    <!-- Invoice Overview -->
                    <p-tabpanel [value]="0">
                        <bm-debt-collection-balance></bm-debt-collection-balance>
                    </p-tabpanel>

                    <!-- Contract Overview -->
                    @if (selectedContract) {
                        <p-tabpanel [value]="1">
                            <mvs-object
                                    [objectType]="'cm.Contract'"
                                    [objectId]="51355"
                                    [uiMode]="'mini-side'"
                            ></mvs-object>
                        </p-tabpanel>
                    }

                </p-tabpanels>

            </p-tabs>
        </div>
    </div>
</div>
